export default __webpack_public_path__ + "static/media/resume.3e6138d1.pdf";